"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SendOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var SendOutlineSVG = function SendOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M29.5 2.56a2 2 0 00-1.99-.53L3.38 8.93a2 2 0 00-.56 3.58l9.2 6.13.81.54.54.92 5.22 8.95a1.98 1.98 0 001.72 1 1.62 1.62 0 00.22-.02 2 2 0 001.7-1.38l7.73-24.08a2 2 0 00-.47-2zm-9.18 25.5a.01.01 0 000-.02l-5.49-9.4 5.46-5.45a1 1 0 00-1.42-1.42l-5.42 5.42-9.52-6.34 24.13-6.89z"
  }));
};
exports.SendOutlineSVG = SendOutlineSVG;
SendOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(SendOutlineSVG);
exports.default = _default;